import { Skyjo, Card } from "@/skyjo/game";

export class Player {

    id: number;
    cards: (Card | undefined)[] = [];
    scoreTotal: { score: number, detail: string | null } = { score: 0, detail: null };
    scoresOld: { score: number, detail: string | null }[] = []
    pseudo: string;
    creator: boolean = false;
    beginner: boolean = false;
    closer: boolean = false;
    playing: boolean = false;
    me: boolean = true;

    constructor(id?: number, pseudo?: string) {
        this.creator = id === 0 ? true : false
        this.id = id || 0
        this.pseudo = pseudo || ''
    }

    get score(): number { return this.cards.reduce((acc, card) => (card && card.show) ? acc + card.value : acc, 0) }

    checkColumn(skyjo: Skyjo) {
        for (let i = 0; i < this.cards.length; i = i + 3) {
            const card1 = this.cards[i], card2 = this.cards[i + 1], card3 = this.cards[i + 2]
            if (!card1 || !card2 || !card3) { continue; }
            if (!card1.show || !card2.show || !card3.show) { continue; }
            if (card1.value === card2.value && card2.value === card3.value) {
                [card1, card2, card3].forEach(card => {
                    const cardIndex = this.cards.findIndex((cardToChange) => cardToChange === card)
                    const playerCardPlaceId = 'place' + this.id + '-' + cardIndex
                    skyjo.animation.add(card, false, playerCardPlaceId, 1)
                });
                this.cards.splice(i, 3, undefined, undefined, undefined)
                skyjo.pioche.discard.push(card1, card2, card3);
            }
        }
    }

    get isMyBoard() { return this.me }

    get hasReturnTwoCards(): boolean { return this.cards.reduce((pre, cur) => pre + (cur && cur.show ? 1 : 0), 0) >= 2 }

    returnAllCards(skyjo: Skyjo) {
        this.cards.forEach((card) => {
            if (card && !card.show) {
                card.show = true
                skyjo.animation.add(card, true)
            }
        })
        this.checkColumn(skyjo)
    }

    get isLastTurn(): boolean { return this.cards.reduce((acc, card) => acc + (!card || card.show ? 1 : 0), 0) === this.cards.length }

    resetScore() {
        this.scoresOld.push({ ...this.scoreTotal })
        this.scoreTotal.score = 0
        this.scoreTotal.detail = null
    }

    calculScore() {
        this.scoreTotal.score += this.score;
        this.scoreTotal.detail ??= ''
        this.scoreTotal.detail += this.scoreTotal.detail.length ? ' + ' : '';
        this.scoreTotal.detail += this.score.toString()
    }
}
